const phoneHelper = {};

phoneHelper.convertToCountryCode = (phoneNumber) => {
  // will convert number to +1 (123) 456-7890
  const countryCodePhoneNumberRegex = /\+1[\d]+/g;

  if (countryCodePhoneNumberRegex.test(phoneNumber)) {
    return phoneNumber;
  } else {
    // number doesn't have country code (+1), so add it
    return `+1${phoneNumber}`;
  }
};

phoneHelper.cleanPhoneNumber = (phoneNumber) => {
  // will remove all non-numeric characters to give '1234567890'
  return phoneNumber.replace(/\D/g, "");
};

phoneHelper.formatPhoneNumber = (phoneNumberString) => {
  // will format number to (123) 456-7890
  const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : null;
};

phoneHelper.formattedCountryCodeNumber = (phoneNumber) => {
  // will format number to +1 (123) 456-7890
  const cleanedNumber = phoneHelper.cleanPhoneNumber(phoneNumber);
  return phoneHelper.convertToCountryCode(cleanedNumber);
};

export default phoneHelper;
